import { render, staticRenderFns } from "./FireElectricalCause.vue?vue&type=template&id=12fa9ef5&scoped=true"
import script from "./FireElectricalCause.vue?vue&type=script&lang=ts"
export * from "./FireElectricalCause.vue?vue&type=script&lang=ts"
import style0 from "./FireElectricalCause.vue?vue&type=style&index=0&id=12fa9ef5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa9ef5",
  null
  
)

export default component.exports